"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSpan = exports.ActionContainer = exports.TableSection = exports.ResultPresenterContainer = exports.ConfigurationContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ConfigurationContainer = styled_components_1.default.div `
  padding-top: 40px;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding-right: 40px;

  :last-child {
    padding-right: 0px;
  }
`;
exports.ResultPresenterContainer = styled_components_1.default.div `
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: start;
`;
exports.TableSection = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding-top: 20px;

  table {
    tbody {
      tr {
        td {
          padding-top: 5px;
          padding-bottom: 5px;
          padding-left: 20px;
          padding-right: 20px;
        }
      }
    }
  }
`;
exports.ActionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding-top: 12px;
  min-width: 300px;

  button {
    width: 100%;
    padding: 5px;
  }

  input {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 3px;

    ::placeholder {
      color: #999;
    }
  }
`;
exports.ErrorSpan = styled_components_1.default.span `
  color: #f00;
`;
//# sourceMappingURL=elements.js.map